/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ContenidoForm from './ContenidoModalForm';
import * as validations from '../../validations/validations';
import * as contenidoActions from '../../actions/contenidoActions';
 
import * as tipoContenidoActions from '../../actions/tipoContenidoActions';
import * as crucigramaActions from '../../actions/crucigramaActions';
import * as formularioActions from '../../actions/formularioActions';
import * as usuarioActions from '../../actions/usuarioActions';
import withRouter from '../common/withRouter';


import { Segment} from 'semantic-ui-react'; 
import moment from 'moment';
import $ from 'jquery';
import dayjs from 'dayjs';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {getMargenes} from '../../util/';
import {genericFormattedForDropdownByNombre, genericFormattedForDropdown} from '../../selectors/selectors';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';


class ManageContenidoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            fechaStr: new moment().format('DD/MM/YYYY'),
			contenido:{
                fecha2: new moment().format('DD/MM/YYYY'),
                fechaInicioExamen: new moment().format('DD/MM/YYYY'),
                fechaTerminoExamen: new moment().format('DD/MM/YYYY'),
            },
            archivo:{
                imagePreviewUrl:null,
                pdf:0
            },
		};
		
	}
    
    
    componentDidMount(){
         usuarioActual(this, "contenido",true).then( (usuario)=>{
             
       
             
        let id=this.props.idModuloContenido;
        
        this.props.tipoContenidoActions.getTipoContenidoCombo(usuario).then( ()=>{ 
           
        }) 
        .catch(error=>{ 
          toastr.error(error); 
        });         
         this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
         this.props.formularioActions.getFormularioCombo(usuario).then(()=>{ 
           
        })
        .catch(error=>{
          toastr.error(error);
        }); 
             
             
        this.props.crucigramaActions.getCrucigramaCombo(usuario).then(()=>{ 
           
        })
        .catch(error=>{
          toastr.error(error);
        });      
             
             
        this.props.usuarioActions.getUsuarioCombo(14,usuario).then( ()=>{ 

        }) 
        .catch(error=>{ 
          toastr.error(error); 
        });      
             
            if(id && id>0 ){
            
                this.props.contenidoActions.getContenidoConf(id, usuario).then( contenido=>{
                    
                    
                    if(contenido.fechaInicioExamen===null){
                        contenido.fechaInicioExamen=new moment().format('DD/MM/YYYY');
                    }
                    
                    if(contenido.fechaTerminoExamen===null){
                        contenido.fechaTerminoExamen=new moment().format('DD/MM/YYYY');
                    }
                    
                    this.setState({"contenido":contenido});
                    
                    
                    let archivo = this.state.archivo;    
                    
                    if(contenido.archivo!=null || contenido.idTipo==26 || contenido.idTipo==29){
                           archivo.imagePreviewUrl= contenido.archivo;
                            this.setState({"archivo":archivo});
                    }
                    
                    
                    
                    
                    this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, contenido.prefijo).then( archivos=>{
                        this.setState({"archivos":archivos});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
           })
            .catch(error=>{
              toastr.error(error);
            }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		
   
		
    }
    
    
    goBack=()=>{
         this.props.history.goBack();
    }

    handleChange=(event, data)=> {

        let contenido = this.state.contenido;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		contenido[field[0]]= value;
		else{
             if(!contenido[field[0]]){
                    contenido[field[0]]={}
                }
			contenido[field[0]][field[1]]= value;
		}
        
        
        /*
		if(field=="idTipo" && contenido.prefijo!=""){
       
            this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, value).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        */
        this.setState({"contenido": contenido});
    }
    
    
    onBuscar=(event)=>{
        event.preventDefault();
        let contenido = this.state.contenido;
        
        if( contenido.idTipo!="" && contenido.prefijo!=""){
            this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, contenido.prefijo).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let contenido=this.state.contenido;
        let archivo=this.state.archivo;
           
        if(!validations.requerido(contenido.agrupador)){
            errors.agrupador=true;
            formIsValid=false;
        }
              
        if(!validations.requerido(contenido.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contenido.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contenido.tiempo)){
            errors.tiempo=true;
            formIsValid=false;
        }
        
        
        //if((contenido.idTipo==26||contenido.idTipo==27||contenido.idTipo==29) &&
        
        if((contenido.idTipo==27) && !validations.requerido(contenido.archivo)){
            errors.archivo=true;
            formIsValid=false;
        }
        /*  
        if((contenido.idTipo==26||contenido.idTipo==29) && !validations.requerido(archivo)){
            errors.archivoF=true;
            formIsValid=false;
        }
        */
       
        if(!validations.requerido(contenido.idTipo)){
            errors.idTipo=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

    fecha=(fechasArreglo, fechasCadena, tipo)=>{
            let contenido = this.state.contenido;
        
        
             console.log(tipo);
            if(tipo==="agrupador"){
                contenido.fecha2 = fechasCadena;
                contenido.fecha2JS = fechasArreglo;
            }
        
            if(tipo==="fechaInicioExamen"){
                contenido.fechaInicioExamen = fechasCadena;
                contenido.fechaInicioExamenJS = fechasArreglo;
            }
        
            if(tipo==="fechaTerminoExamen"){
                contenido.fechaTerminoExamen = fechasCadena;
                contenido.fechaTerminoExamenJS = fechasArreglo;
            }
            
            console.log(contenido);
            this.setState({contenido:contenido});
    }
  
    
    HandleFileImagen=(event, data)=> {
        
        
        let tamano;
        let imagen;
        let contenido = this.state.contenido;
        
        imagen = this.state.archivo;
        
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            
        
                imagen.fileReg = '';
                imagen.imagePreviewUrl='';
                imagen.pdf=0;
                this.setState({"archivo": imagen});
            
            return;
        }


        if(event.target.files[0].size<=((1024*1024)*5)){
            
            imagen['fileReg'] = event.target.files[0];
            
            if(contenido.idTipo===29){
                imagen['pdf'] = 0;
                imagen['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            }else{
                imagen['pdf'] = 1;
                imagen['imagePreviewUrl'] = '';
            }
            this.setState({"archivo": imagen});
            
            return;
            
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imagen.fileReg = '';
            imagen.imagePreviewUrl='';
            imagen.pdf=0;
            this.setState({"imgBanner": imagen});
          
            if(contenido.idTipo==26){
            //PDF
                toastr.error("El archivo PDF desea anexar mide "+tamano.toFixed(2)+
                         " Mb. No se permiten imagnees mayores a 5 Mb!!!");
            }
                
            if(contenido.idTipo==29){
                toastr.error("El archivo de imagen desea anexar mide "+tamano.toFixed(2)+
                         " Mb. No se permiten imagnees mayores a 5 Mb!!!");
            
            }
                
            return;
        } 
         
     }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        let contenidoModulo=Object.assign({}, this.state.contenido);
        //console.log(this.props);
        //contenidoModulo.idModulo = this.props.contenidoView[0].idModulo ;
        contenidoModulo.idModulo = this.props.idModuloActivo;
        contenidoModulo.fecha2 = dayjs(this.state.contenido.fecha2JS).format('DD/MM/YYYY');
        
        
        if(this.state.contenido.fechaInicioExamenJS){
            console.log("Fecha Inicio Existe");
            contenidoModulo.fechaInicioExamen = dayjs(this.state.contenido.fechaInicioExamenJS).format('DD/MM/YYYY HH:mm');
        }else{
            console.log("Fecha Inicio NO Existe");
        }
        
        if(this.state.contenido.fechaTerminoExamenJS){
            console.log("Fecha Fin Existe");
            contenidoModulo.fechaTerminoExamen = dayjs(this.state.contenido.fechaTerminoExamenJS).format('DD/MM/YYYY HH:mm');
        }else{
            console.log("Fecha Fin No Existe");
        }
        
        //console.log(contenidoModulo);
        
        var archivo = this.state.archivo.fileReg;
        
        
        this.props.contenidoActions.saveConfig(contenidoModulo, this.props.user).then((contenido) => {
            toastr.success("Registro guardado!!!.");
            this.props.cargarContenido(this.props.idModuloActivo);
            
            var archivo = this.state.archivo.fileReg;
            if(archivo instanceof File){

                var form_data = new FormData();
                form_data.append('file', archivo);
                form_data.append('contendioId', contenido.id);
                
                
            
           
                this.props.contenidoActions.saveFile(form_data, this.props.user).then((imagen) => {
                    //console.log("guardo y cerro la modal");    
                    toastr.success("Imagen guardada correctamente!!!.");
            this.props.closeModal();
                }).catch(error=>{
                    //console.log("error al guardo y cerro la modal");
                  toastr.error(error.responseJSON.message);
                });
          
            }else{
                    //console.log("solo cerro la modal");
                 this.props.closeModal();
                
            }
            
            
        });
        
    }
    
      close=()=>{
        
         this.props.closeModal();
    }


       
    render() {	
         let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
		return (
                <ContenidoForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.contenido}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
                    tipoContenidoCombo={genericFormattedForDropdown(this.props.tipoContenidoCombo)}
                    formularioCombo={genericFormattedForDropdown(this.props.formularioCombo)}
                    crucigramaCombo={genericFormattedForDropdown(this.props.crucigramaCombo)}
                    comboInstructor={genericFormattedForDropdown(this.props.usuarioCombo)}
                    
                    onBuscar={this.onBuscar}
                    goBack={this.goBack}
                    
                    close={this.close}
                    fecha={this.fecha}
                    fechaStr={this.state.fechaStr}
                    
                    archivo={this.state.archivo}
                    onHandleFileImagen={this.HandleFileImagen}
                />

		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        //id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        color:state.color,
        tipoContenidoCombo:state.tipoContenidoCombo,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings,
        form:state.form,
        formularioCombo: state.formularioCombo,
        usuarioCombo:state.usuarioCombo,
        crucigramaCombo: state.crucigramaCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions:bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        tipoContenidoActions: bindActionCreators(tipoContenidoActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        crucigramaActions: bindActionCreators(crucigramaActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageContenidoForm));